module.exports = __webpack_public_path__ + "static/media/camera_selected.f45197fe.svg";